import React from "react";

import { isFunction } from "~/tools/is-function";

export type WrapRenderer = (children: React.ReactNode) => React.ReactElement;

export interface WrapProps {
	if: boolean;
	with: WrapRenderer | React.ReactElement;
	children: React.ReactNode;
}

export const Wrap: React.FC<React.PropsWithChildren<WrapProps>> = ({ if: when, with: wrapper, children }) => {
	if (!when) {
		return <>{children}</>;
	}

	if (isFunction(wrapper)) {
		return wrapper(children);
	}

	return React.cloneElement(wrapper, {}, children);
};
